import _ from 'lodash';
import React from 'react';
import { Button, notification } from 'antd';
import { Mutation } from '@apollo/react-components';
import { withApollo } from '@apollo/react-hoc';
import pluralize from 'pluralize';
import { gql } from '@apollo/client';
import { track } from '$lib/tracking';

const COMPLETE_CONTENT = gql`
  mutation CompleteContent($input: CompleteContentInput!) {
    completeContent(input: $input) {
      content {
        uuid
        completedAt
        numItems
      }
    }
  }
`;

const EARLY_ACCESS_SLUGS = ['amc-8', 'amc-10', 'amc-12'];

const handleComplete = async ({ uuid, completeContent }) => {
  track('Topic | Completed', { contentUuid: uuid });
  const { data } = await completeContent({
    variables: {
      input: {
        uuid,
      },
    },
  });

  const {
    completeContent: { content },
  } = data;
  const { numItems } = content;

  const description =
    numItems && numItems > 0
      ? `Great job! Added ${pluralize('review', numItems, true)}.`
      : 'Nice work!';

  notification.success({
    message: 'Chapter completed',
    description,
  });
};

const CompleteContentButton = (props) => {
  const { className, contentInstance, productSlug } = props;
  const { uuid, completedAt, numItems } = contentInstance;
  const buttonText = completedAt ? 'Completed' : 'Complete';

  return (
    <Mutation mutation={COMPLETE_CONTENT}>
      {(completeContent, { loading: completeContentLoading }) => {
        const disabled =
          completedAt ||
          completeContentLoading ||
          (_.includes(EARLY_ACCESS_SLUGS, productSlug) && numItems === 0);
        return (
          <Button
            data-aaa="completeContentButton"
            onClick={() => handleComplete({ uuid, completeContent })}
            disabled={disabled}
            loading={completeContentLoading}
            className={className}
          >
            {buttonText}
          </Button>
        );
      }}
    </Mutation>
  );
};

export default withApollo(CompleteContentButton);
